import React, {Component} from "react";
import "./login.scss";
import headerLogo from './../../../assets/new-logo.svg';
import {Helmet} from "react-helmet";
import Repeater from "../../../components/repeater/repeater";
import {Grid} from "semantic-ui-react";
import {AuthService} from "../../../services/auth-service";
import ClientElement from "../accounts/client-element"

class SwitchUserClient extends Component {

    constructor(props) {
        super(props);
        this.authService = new AuthService();

        this.state = {
            clientList: this.authService.validClients()
        };
    }

    
    componentDidMount() {
    }

    componentDidUpdate() {
        
    }
    
    render() {
       
        return (
            <div className="client-selector">

                <Helmet>
                    <title>Inenco Portal | Account Selection</title>
                </Helmet>

                <img src={headerLogo} alt="header-logo" id="logo"/>
                <h4>Please select an account</h4>



              
            <Repeater data={this.state.clientList} component={ClientElement} onElementInteraction={this.props.onSelectedClient}>
                <Repeater.Header>
                    <Grid  stackable columns='equal' verticalAlign='middle'>
                      </Grid>
                </Repeater.Header>
                <Repeater.Footer>
                    <Grid  stackable columns='equal'>
                        <Grid.Row>
                            <Grid.Column>
                              
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Repeater.Footer>
            </Repeater>
                {/* <FilterableRepeater data={this.state.clientList} component={ClientElement} textFilterFields={["name"]} onElementInteraction={this.props.onSelectedClient}/> */}

            </div>
        );
            
    }
}

export default  SwitchUserClient;
